export default __webpack_public_path__ + "static/media/002-two-ways.89a4e2fa.png";